module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Water-Walking: Discovering and Obeying Your Call to Radical Discipleship")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780310632016_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "PREFACE"
    }
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "pre"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpre"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" want to invite you to go for a walk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bible is, among other things, a list of unforgettable walks. The first one was taken by God himself, who, we are told, used to walk in the garden in the cool of the day. But as a general rule, God asked people to walk with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was the hard walk that Abraham took with his son Isaac on the road to Moriah. There was the liberating walk Moses and the Israelites took through the path that was normally occupied by the Red Sea, and the frustrating walk that took them on the roundabout way of the desert for forty years. There was Joshua’s triumphant walk around Jericho, the disciples’ illuminating walk to Emmaus, Paul’s interrupted walk to Damascus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_b"
  }, [_vm._v("But perhaps the most unforgettable walk of all was taken by Peter the day he got out of a boat and walked on the water. It is unforgettable not so much because of where he was walking as what he was walking "), _c('i', [_vm._v("on")]), _vm._v(" and who he was walking "), _c('i', [_vm._v("with")]), _vm._v(". In this book, let Peter’s walk stand as "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_vm._v("an invitation to everyone who, like him, wants to step out in faith, who wants to experience something more of the power and presence of God. There is a consistent pattern in Scripture of what happens in a life that God wants to use and improve:")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("There is always a call.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("There is always fear.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("There is always reassurance. God promises his presence.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("There is always a decision. Sometimes, as with Moses and Gideon, people say yes to God’s call. Sometimes, as with the ten frightened spies or the rich young ruler who spoke with Jesus, they say no.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("There is always a changed life. Those who say no are changed too. They become a little harder, a little more resistant to his calling, a little more likely to say no the next time.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_t"
  }, [_vm._v("I believe that this pattern from Scripture continues today. Together with this book we are going to learn the skills essential to “water-walking”: discerning God’s call, transcending fear, risking faith, managing failure, trusting God. I want to invite you to go for a walk. On the water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just remember one thing: If you want to walk on water, you’ve got to get out of the boat.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d5370d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310632016_Preface.vue
// module id = 75
// module chunks = 0